/*
  Conditional Product Grid placement logic
  - Builds CSS Grid template areas for tiles with row/column spans
  - Matches existing magazine-style behavior
  - Adds ratio classes: 1/1->ratio-regular, 1/2->ratio-tall, 2/1->ratio-wide, 2/2->ratio-large
  - Handles 4 columns desktop, 2 columns mobile
  - Gaps: desktop (20px vertical, 27px horizontal), mobile (20px vertical, 13px horizontal)
*/

(function () {
  var CLASS_MAP = {
    '1/1': 'ratio-regular',
    '1/2': 'ratio-tall',
    '2/1': 'ratio-wide',
    '2/2': 'ratio-large'
  };

  function isMobile() { return window.innerWidth < 1024; }

  function getColumns(container) {
    var mobileCols = parseInt(container.getAttribute('data-columns-mobile') || '2', 10);
    var desktopCols = parseInt(container.getAttribute('data-columns-desktop') || '4', 10);
    return isMobile() ? mobileCols : desktopCols;
  }

  function getGaps(container) {
    if (isMobile()) {
      var h = parseInt(container.getAttribute('data-gap-mobile-h') || container.getAttribute('data-gap-mobile') || '13', 10);
      var v = parseInt(container.getAttribute('data-gap-mobile-v') || '20', 10);
      return { v: v, h: h };
    }
    return {
      v: parseInt(container.getAttribute('data-gap-desktop-v') || '20', 10),
      h: parseInt(container.getAttribute('data-gap-desktop-h') || '27', 10)
    };
  }

  function readItems(container) {
    var nodes = container.querySelectorAll('[data-cpg-item]');
    var items = [];
    nodes.forEach(function (el, idx) {
      var rs = parseInt(el.getAttribute('data-row-span') || '1', 10);
      var cs = parseInt(el.getAttribute('data-column-span') || '1', 10);
      if (rs !== 1 && rs !== 2) rs = 1;
      if (cs !== 1 && cs !== 2) cs = 1;
      items.push({ el: el, rowSpan: rs, colSpan: cs, index: idx });
    });
    return items;
  }

  function ensureRows(grid, cols, extra) {
    for (var i = 0; i < extra; i++) { grid.push(Array(cols).fill('.')); }
  }

  function placeItems(items, cols) {
    // Start with a reasonable number of rows; grow as needed
    var rows = Math.max(4, Math.ceil(items.length * 2));
    var grid = [];
    ensureRows(grid, cols, rows);

    var areas = [];
    items.forEach(function (item) {
      var areaName = 'item-' + item.index;
      var placed = false;
      var r = 0, c = 0;
      while (!placed) {
        // advance to next available cell if current is occupied
        if (grid[r][c] !== '.') {
          c++;
          if (c >= cols) { c = 0; r++; }
          if (r >= grid.length) { ensureRows(grid, cols, cols); }
          continue;
        }

        // check if item fits at (r,c)
        var fits = true;
        for (var rr = 0; rr < item.rowSpan && fits; rr++) {
          for (var cc = 0; cc < item.colSpan && fits; cc++) {
            var tr = r + rr, tc = c + cc;
            if (tr >= grid.length || tc >= cols || grid[tr][tc] !== '.') { fits = false; }
          }
        }
        if (fits) {
          // mark area
          for (var rr2 = 0; rr2 < item.rowSpan; rr2++) {
            for (var cc2 = 0; cc2 < item.colSpan; cc2++) {
              grid[r + rr2][c + cc2] = areaName;
            }
          }
          areas.push({ name: areaName, row: r, col: c, rowSpan: item.rowSpan, colSpan: item.colSpan });
          placed = true;
        } else {
          c++;
          if (c >= cols) { c = 0; r++; }
          if (r >= grid.length) { ensureRows(grid, cols, cols); }
        }
      }
    });

    // Build template areas string, trimming trailing empty rows
    var trimmedGrid = grid.slice();
    while (trimmedGrid.length && trimmedGrid[trimmedGrid.length - 1].every(function (cell) { return cell === '.'; })) {
      trimmedGrid.pop();
    }
    var templateAreas = trimmedGrid.map(function (row) { return '"' + row.join(' ') + '"'; }).join(' ');

    return { grid: trimmedGrid, areas: areas, templateAreas: templateAreas };
  }

  function applyLayout(container) {
    var cols = getColumns(container);
    var gaps = getGaps(container);
    var items = readItems(container);
    var result = placeItems(items, cols);

    // set container styles
    container.style.display = 'grid';
    // Equal column widths accounting for horizontal gap: calc(100%/cols - gap*(cols-1)/cols)
    var colWidth = 'calc((100% / ' + cols + ') - ' + ((gaps.h * (cols - 1)) / cols).toFixed(2) + 'px)';
    var templateCols = Array(cols).fill(colWidth).join(' ');
    container.style.gridTemplateColumns = templateCols;
    container.style.gridTemplateAreas = result.templateAreas;
    container.style.gap = gaps.v + 'px ' + gaps.h + 'px';

    // apply each item gridArea and ratio class mapping
    items.forEach(function (item) {
      var areaName = 'item-' + item.index;
      item.el.style.gridArea = areaName;
      var key = item.colSpan + '/' + item.rowSpan;
      var cls = CLASS_MAP[key] || CLASS_MAP['1/1'];
      item.el.classList.remove('ratio-regular', 'ratio-tall', 'ratio-wide', 'ratio-large');
      item.el.classList.add(cls);
    });
  }

  var MRConditionalProductGrid = {
    init: function (sectionRoot) {
      var container = sectionRoot.querySelector('[data-cpg-container]');
      if (!container) return;
      // initial layout
      applyLayout(container);
      // resize handling
      var prevCols = getColumns(container);
      var onResize = function () {
        var colsNow = getColumns(container);
        if (colsNow !== prevCols) {
          prevCols = colsNow;
          applyLayout(container);
        }
      };
      window.addEventListener('resize', onResize);
    }
  };

  window.MRConditionalProductGrid = MRConditionalProductGrid;
})();
